module.exports = __webpack_public_path__ + "img/b+control.5aaffdd.png";